import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@mui/material";
import React from "react";
import { SkeletonDistribution, SkeletonVariant } from "@/stores/modal-store.types";
interface ModalSkeletonProps {
  className?: string;
  header?: {
    show?: boolean;
    height?: number;
  };
  title?: {
    show?: boolean;
    height?: number;
  };
  content?: {
    distribution?: SkeletonDistribution;
    items?: {
      count?: number;
      height?: number | string;
      gap?: number;
      variant?: SkeletonVariant;
    }[];
  };
}
export const ModalSkeleton: React.FC<ModalSkeletonProps> = t0 => {
  const $ = _c(23);
  const {
    className,
    header: t1,
    title: t2,
    content
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      show: true,
      height: 24
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const header = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {
      show: true,
      height: 32
    } : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const title = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      distribution: "auto",
      items: [{
        count: 1,
        height: 100,
        variant: "rectangular"
      }, {
        count: 2,
        height: 80,
        gap: 4,
        variant: "rectangular"
      }, {
        count: 1,
        height: 120,
        variant: "rectangular"
      }]
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const defaultContent = t5;
  const skeletonContent = content || defaultContent;
  const t6 = `w-full flex flex-col ${className || ""}`;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      height: "auto"
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== header.height || $[7] !== header.show) {
    t8 = header.show && <div className="p-6 flex items-center justify-between shrink-0"><Skeleton variant="text" width="40%" height={header.height} /></div>;
    $[6] = header.height;
    $[7] = header.show;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== title.height || $[10] !== title.show) {
    t9 = title.show && <div className="flex justify-between items-center mb-8 shrink-0"><Skeleton variant="text" width="30%" height={title.height} /><Skeleton variant="circular" width={40} height={40} /></div>;
    $[9] = title.height;
    $[10] = title.show;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== skeletonContent.items) {
    t10 = skeletonContent.items?.map(_temp);
    $[12] = skeletonContent.items;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <div className="space-y-4">{t10}</div>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t9) {
    t12 = <div className="flex-1 p-6 overflow-y-auto">{t9}{t11}</div>;
    $[16] = t11;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6 || $[21] !== t8) {
    t13 = <div className={t6} style={t7}>{t8}{t12}</div>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t8;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
function _temp(item, index) {
  const itemHeight = typeof item.height === "string" ? parseInt(item.height) * 6 : item.height;
  return <div key={index} className="w-full" style={{
    minHeight: `${itemHeight}px`
  }}>{item.count && item.count > 1 ? <div className="grid grid-cols-2 gap-4">{Array.from({
        length: item.count
      }).map((_, i) => <Skeleton key={i} variant={item.variant as "rectangular" | "circular" | "text"} height={itemHeight} className="w-full" />)}</div> : <Skeleton variant={item.variant as "rectangular" | "circular" | "text"} height={itemHeight} className="w-full" />}</div>;
}